import * as React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { validarToken } from "./herramientas/JWT";
import LogOut from "./Auth/LogOut";
import { Error400, Error401, Error403, Error404, Error500, Error503,AdminstracionPage } from "./pages";
import { LoginPage,LoginPageNew, ProfilePage , DashboardOtd, DetalleRemolques, UpdateRemolques, OrdenesClientePage,MovDownload,MovDownLoadHellmann,MainAsignaciones,MainWTI, OperadoresTransportistasPage, RegistroHorarios} from "./pages";
import { TrackingPage, MonitoreoPage, MovimientosNavierosClientePage , LocalidadesTransportistasPage,RemolquesTransportistasPage, MonitoreoOTD,KPI ,ContactosPage, EstatusGerenciador,MetricasTransportista} from "./pages";
import { CelloIntegrationPage } from "./pages";
import RuteadorPage from "./pages/RuteadorPage/RuteadorPage";
import RemolquesPage from "./pages/AdministradorTransportista/Remolques/RemolquesPage.react";
import TractosPage from "./pages/AdministradorTransportista/Tractos/TractosPage.react";
import GpsDevolucionPage from "./pages/AdministradorTransportista/GpsDevolucion/GpsDevolucionPage.react";
import GpsPorRecuperarPage from "./pages/AdministradorTransportista/GpsPorRecuperar/GpsPorRecuperarPage.react";



import "tabler-react/dist/Tabler.css";

var user= JSON.parse(sessionStorage.getItem("usuario"));

function changeTema(){

  if(user){if( localStorage.getItem('skyonetema'+user.id) === "2" ){
    require ("./Temas/TablerDark.css");
  }else{
    if( localStorage.getItem('skyonetema'+user.id) === "1" ){
      require ("./Temas/TablerDefault.css");
    }
  }}else{
    require ("./Temas/TablerDefault.css");
  }
}

document.querySelector('body').style.backgroundImage = "url('images/imagenFondo.jpg')";
document.querySelector('body').style.backgroundSize = "cover";
type Props = {||};
function App(props: Props): React.Node {
  return (
    <div>{ !window.location.href.toUpperCase().includes("/LOGIN") && !window.location.href.toUpperCase().includes("/ONELINE")? validarToken(sessionStorage.getItem("tok")): null }
      { changeTema() }
      <React.StrictMode>
        <Router>
          <Switch>
            <Route exact path="/" component={Error403} />
            <Route exact path="/400"                  component={Error400} />
            <Route exact path="/401"                  component={Error401} />
            <Route exact path="/403"                  component={Error403} />
            <Route exact path="/404"                  component={Error404} />
            <Route exact path="/500"                  component={Error500} />
            <Route exact path="/503"                  component={Error503} />
            <Route exact path="/logout"               component={LogOut} />
            <Route exact path="/login"                component={LoginPage} />
            <Route exact path="/oneline"                component={LoginPageNew} />
            <Route exact path="/perfilusuario"        component={ ProfilePage } />            
            <Route exact path="/tracking"             component={TrackingPage} />
            <Route exact path="/monitoreo"            component={MonitoreoPage} />
            <Route exact path="/movimientos_nav_clien"component={MovimientosNavierosClientePage} />
            <Route exact path="/dashboard_otd"        component={DashboardOtd} />
            <Route exact path="/remolques"            component={RemolquesPage}/>
            <Route exact path="/tractos"              component={TractosPage}/>
            <Route exact path="/detalleRemolques"    component={DetalleRemolques}/>
            <Route exact path="/update_remolques"     component={UpdateRemolques}/>
            <Route exact path="/ordenescliente"       component={OrdenesClientePage}/>
            <Route exact path="/descarga_mov_maerks"  component={MovDownload}/>
            <Route exact path="/descarga_mov_hellmann"component={MovDownLoadHellmann}/>
            <Route exact path="/localidades"          component={LocalidadesTransportistasPage}/>
            <Route exact path="/remolquesTransportista"component={RemolquesTransportistasPage}/>
            <Route exact path="/monitoreoOTD"component={MonitoreoOTD}/>
            <Route exact path="/correosNotificaciones"component={ContactosPage}/>
            <Route exact path="/metricasUnidadesAsignadasGps" component={MainAsignaciones}/>
            <Route exact path="/wti" component={MainWTI}/>
            <Route exact path="/gerenciador" component={EstatusGerenciador}/>
            <Route exact path="/administracion" component={AdminstracionPage} />
            <Route exact path="/catalogo-operadores" component={OperadoresTransportistasPage}/>
            <Route exact path="/gps-devolucion" component={GpsDevolucionPage}/>
            <Route exact path="/gps-por-recuperar" component={GpsPorRecuperarPage}/>
            <Route exact path="/registroHorarios" component={RegistroHorarios} />
            <Route exact path="/ruteador" component={RuteadorPage} />
            <Route exact path="/metricasTransportista" component={MetricasTransportista} />
            <Route exact path="/cello-integration" component={CelloIntegrationPage} />
            <Route component={Error404} />
          </Switch>
        </Router>
      </React.StrictMode>
    </div>
  );
}

export default App;
